import StatusBadge, { StatusTone } from "@buildpy/ui/status-badge";
import { PROJECT_STATUS_LABEL, ProjectStatus } from "@buildpy/core/modules/project/types";

// 상태 → 톤. 톤표는 components/status-badge 와 디자인 시스템 StatusBadge 표를 따른다.
export const PROJECT_STATUS_TONE: Record<ProjectStatus, StatusTone> = {
  SCHEDULED: "new",
  IN_PROGRESS: "progress",
  WARRANTY: "progress",
  CLOSED: "done",
};

interface Props {
  status: ProjectStatus;
  className?: string;
}

const ProjectStatusBadge = ({ status, className }: Props) => (
  <StatusBadge className={className} label={PROJECT_STATUS_LABEL[status]} tone={PROJECT_STATUS_TONE[status]} />
);

export default ProjectStatusBadge;
